import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_holiday_prep: FaireThemeEntity = {
  token: "discovery_theme_holiday-prep",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Holiday Prep Essentials",
  description: "Get ahead on seasonal decorating and gifting",
  bgColor: "#F0D4D4",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
